import type { BundledMap } from '@yimoka/i18n';
import { createI18n } from '@yimoka/i18n/react';
import { useSyncExternalStore } from 'react';

import { getEnv } from '@/env';
import { apiExecutor } from '@/http';

import { DEFAULT_LANGUAGE, getCurrentLanguage, subscribeLanguage, SUPPORT_LANGUAGES } from './language';

function useLanguage() {
  return useSyncExternalStore(subscribeLanguage, getCurrentLanguage, getCurrentLanguage);
}

/** host 与 federation remote 共享语言状态和端口约定，但各自注入所属模块的 bundled 资源。 */
export function createTenantWebI18n<TBundled extends BundledMap>(bundled: TBundled, storagePrefix: string) {
  const env = getEnv();

  return createI18n({
    bundled,
    defaultLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORT_LANGUAGES.map(item => item.value),
    useLang: useLanguage,
    fetchRemote: env.remoteI18n ? (lang => apiExecutor({
      url: '/shared/frontend/portal/object/content',
      method: 'GET',
      params: {
        name: `${env.appId}-i18n`,
      },
      headers: {
        'x-md-global-language': lang,
      },
    })) : undefined,
    storage: {
      get: key => Promise.resolve(typeof localStorage?.getItem === 'function' ? localStorage.getItem(key) : null),
      set: (key, value) => {
        if (typeof localStorage?.setItem === 'function') {
          localStorage.setItem(key, value);
        }
        return Promise.resolve();
      },
      prefix: storagePrefix,
    },
    subscribeAppResume: (onResume) => {
      const handler = () => {
        if (document.visibilityState === 'visible') onResume();
      };
      document.addEventListener('visibilitychange', handler);
      return () => document.removeEventListener('visibilitychange', handler);
    },
  });
}
